import { useState, useEffect } from 'react'
import { intervalToDuration } from 'date-fns';
import * as Promise from "bluebird";
import { useMediaQuery } from 'react-responsive'

import { fetchProduct, fetchSkusByProduct, fetchSkuAvailabilitiesDistribution, eventLog } from './api'
import { getLowestPrice, evalFunc, makeReqUriFromLoc, SESSION_ID } from './utils';


import CartButton from './CartButton'
import RentalModal from './RentalModal'
import CheckoutPopup from './CheckoutPopup'
import  IFrame from './IFrame';

import './App.css';

function App({ initialLocation }) {
  const [ pageProduct, setPageProduct ] = useState(null)
  const [ showPopup, setShowPopup ] = useState(false)
  const [ showModal, setShowModal ] = useState(null)
  const [ count, setCount ] = useState(0)
  const [ dateRange, setDateRange ] = useState(null)
  const [ cart, setCart ] = useState(null)
  const [ productData, setProductData ] = useState(null)
  const [ disabledButton, setDisabledButton ] = useState(false)
  const [ isActiveDayDelivery, setActiveDayDelivery ] = useState(false);
  const [ areaPostcode, onSetPostcode ] = useState(null);
  const [ showIframe, setShowIframe ] = useState(false);
  const [ isPickUp, setIsPickUp ] = useState(false);
  const [ vendorSlug, setVendorSlug ] = useState(false);
  const [ sameDayDeliveryAvailable, setSameDayDeliveryAvailable ] = useState(true);

  const isDesktop = useMediaQuery({ query: '(min-width: 1200px )'});
  const isMobile = useMediaQuery({ query: '(max-width: 767px )'});
  const isMobilePopup = useMediaQuery({ query: '(max-width: 699px )'});

  const [location, setLocation] = useState(initialLocation);

  let popupOpen = false;

  useEffect(() => {
    window.addEventListener('rntr_locationchange', () => {
      const newLocation = window.location.origin + window.location.pathname
      setLocation(newLocation)
    })

    // If location has query rntr=ready, then show popup
    const urlParams = new URLSearchParams(window.location.search);
    const ready = urlParams.get('rntr');

    if (ready === 'ready') {
      popupOpen = true;
    }
  }, [])

  useEffect(() => {
    /*
      Load product by location
    */
    const init = async() => {
      const { userAgent: browserInfo, language: languageInfo } = navigator;
      const { devicePixelRatio: pixelRatio, innerWidth: windowWidth, innerHeight: windowHeight } = window;
      const { width: screenWidth, height: screenHeight } = window.screen;
      const { referrer: referrerUrl } = document;
      const timezone = new Date().getTimezoneOffset();

      eventLog({
        event_id: 1,
        browserInfo,
        languageInfo,
        screenWidth,
        screenHeight,
        pixelRatio,
        timezone,
        referrerUrl,
        windowWidth,
        windowHeight,
      });

      const url = makeReqUriFromLoc(location)

      fetch(url)
        .then(response => response.json())
        .then(async(data) => {

          if (!data) {
            return
          }

          if (data.error) {
            return
          }

          eventLog({event_id: 2});

          const {
            product,
            SKUs,
            vendor
          } = data

          setVendorSlug(vendor.slug.trim())
          // Below exceptions are for production!!! don't remove!!!!
          if(vendor.slug.trim() === 'rntr-chia-1ck0' ||
              vendor.slug.trim() === 'blaek-store-manly-hgcc'
          ) {
            setIsPickUp(true)
          } else {
            setIsPickUp(false)
          }

          setSameDayDeliveryAvailable(vendor.sameDayDeliveryAvailable)

          if (!SKUs || !SKUs.filter) {
            return
          }

          const activeSKUs = SKUs.filter(s => s.status === 'active')

          if (activeSKUs.length === 0) {
            // console.log('Rntr: inactive product')
            return
          }

          const productsSkuAvs = await Promise.reduce(activeSKUs, async(totalSkus, sku) => {
            const skuAvailables = await fetchSkuAvailabilitiesDistribution(sku.strId);
            return totalSkus.concat(skuAvailables)
          }, [])

          const newProductData = {
            product,
            skus: activeSKUs,
            skuAvs: productsSkuAvs
          }

          setPageProduct(product)
          setProductData(newProductData)

          const renderData = {
            ...data,
            lowestPriceStr: getLowestPrice(activeSKUs),
          }

          let isInjected = false
          if (product.injectScript) {
            isInjected = evalFunc(product.injectScript, renderData)
          }
          if (!isInjected && vendor && vendor.injectJS) {
            evalFunc(vendor.injectJS, renderData)
          }

          if (vendor && vendor.injectCSS) {
            const st = document.createElement('style')

            st.innerHTML = vendor.injectCSS
            document.head.appendChild(st)
          }

          setShowModal(popupOpen);
        })
        .catch((e) => {})

      try {
        await setCartData()
        checkCount()
        checkDateRange()
      } catch(e) {
        console.log('error @setCardData', e)
      }
    }

    init()

  }, [location])

  useEffect(() => {
    const onRentButton = async (target) => {
      // adding product to cart
      if (target && target.dataset && target.dataset.id) {
        const productId = target.dataset.id;
        const [ product, skus ] = await Promise.all([ fetchProduct(productId), fetchSkusByProduct(productId)]);

        const skusWithPricing = skus.filter(sku => sku.pricing && sku.pricing.length && !sku.pricing.some(el => !el.price));

        if(!skusWithPricing.length) {
          setDisabledButton(true);
          // console.log('Rntr: all SKUs have not pricing')
        } else {
          setDisabledButton(false);
        }

        setPageProduct(product)

        const productsSkuAvs = await Promise.reduce(skusWithPricing, async(totalSkus, sku) => {
          const skuAvailables = await fetchSkuAvailabilitiesDistribution(sku.strId);
          return totalSkus.concat(skuAvailables)
        }, [])
        const newProductData = {
          product,
          skus: skusWithPricing,
          skuAvs: productsSkuAvs
        }
        setProductData(newProductData)
        // console.log('@onRentButtonClick', newProductData)
      }

      setShowModal('product')
      setShowPopup(false)
      checkCount()
      checkDateRange()
    }

    const onDocumentClick = (e) => {
      // console.log('Rntr: document click', e)
      const target = e.target
      if (!target || !target.className) {
        return
      }

      if (target.className && typeof target.className.indexOf === 'function' &&  (target.className.indexOf('rntr_actionBtn') > -1 || target.className.indexOf('rntr_rent-button') > -1)) {
        // if (target.className && typeof target.className.indexOf === 'function' &&  target.className.indexOf('rntr_rent-button') > -1) {
        eventLog({event_id: 3});
        onRentButton(target)
      }


      if (target.className && typeof target.className.indexOf === 'function' &&  target.className.indexOf('rntr_learn-info') > -1 ) {
        eventLog({event_id: 6});
        setShowIframe(true)
      }
    }

    document.addEventListener('click', onDocumentClick)

    return () => {
      document.removeEventListener('click', onDocumentClick)
    }
  }, [pageProduct])

  const getRentalData = () => {
    const jsonRentalData = localStorage.getItem('rentalData');
    const rentalData = jsonRentalData ? JSON.parse(jsonRentalData) : null;

    return rentalData
  }

  const setCartData = async () => {
    const rentalData = getRentalData()
    const skusIdsInCart = rentalData ? rentalData.skus.map(item => item.strId) : []
    const skusAvsInCart = await Promise.reduce(skusIdsInCart, async(totalSkus, skuId) => {
      const skuAvailables = await fetchSkuAvailabilitiesDistribution(skuId);
      return totalSkus.concat(skuAvailables)
    }, [])

    const cartData = {
      products: rentalData ? rentalData.products : [],
      skus: rentalData ? rentalData.skus : [],
      skuAvs: skusAvsInCart
    }

    setCart(cartData);
  }

  const handleApply = (data) => {
    const { currentSku } = data;
    const rentalData = getRentalData()
    const rentalSessionId = SESSION_ID
    const newRentalData = {
      ...rentalData,
      dateFrom: data.dateRange[0],
      dateTo: data.dateRange[1],
      isSameDayDelivery: isActiveDayDelivery,
      sessionId: rentalSessionId
    }

    if(currentSku) {
      const rentalData = getRentalData()
      const products = rentalData ? rentalData.products : []
      const pageProductIndex = products.findIndex(item => item.strId === pageProduct.strId && item.skuId === currentSku.strId)

      if(pageProductIndex !== -1) {
        const currentProduct = products[pageProductIndex]
        if(currentProduct.skuId === currentSku.strId) {
          products.splice(pageProductIndex, 1, { ...currentProduct, amount: currentProduct.amount + 1 } )
        } else {
          products.push({ ...pageProduct, amount: 1, skuId: currentSku.strId  })
        }
      } else {
        products.push({ ...pageProduct, amount: 1, skuId: currentSku.strId  })
      }

      newRentalData.products = products;
      newRentalData.skus = data.skus
      const productsCount = getProductsCount(products);
      setCount(productsCount)
      eventLog({event_id: 4});
    }

    const newJsonRentalData = JSON.stringify(newRentalData)
    localStorage.setItem('rentalData', newJsonRentalData)
    setCartData()

    setShowModal(null)
    setShowPopup(true)
    checkDateRange()
    setActiveDayDelivery(false)
    onSetPostcode(null)
  }

  const handleHide = () => {
    setShowModal(null)
    setActiveDayDelivery(false)
    onSetPostcode(null)

    eventLog({event_id: 8});
  }

  const getProductsCount = (rentalProducts) => {
    return rentalProducts.reduce((acc, cur) => {
      return acc + cur.amount
    }, 0)
  }

  const checkCount = () => {
    const rentalData = getRentalData();
    const rentalProducts = rentalData ? rentalData.products : []
    const productsCount = getProductsCount(rentalProducts)
    setCount(productsCount)
  }

  const checkDateRange = () => {
    let newDateRange = null
    const rentalData = getRentalData();
    if(rentalData) {
      const { dateFrom, dateTo } = rentalData;
      newDateRange = { dateFrom, dateTo }
    }
    setDateRange(newDateRange)
  }

  const minPrice = (pricing) => {
    let lowestPrice = ''
    let lowestPriceCurrency = ''
    for (const { price, currency } of pricing) {
      if (Number(price) < Number(lowestPrice) || !lowestPrice) {
        lowestPrice = price
        lowestPriceCurrency = currency
      }
    }
    if (lowestPrice && lowestPriceCurrency) {
      return `${lowestPrice} ${lowestPriceCurrency}`
    }

    return lowestPrice
  }

  const getTotalPrice = () => {
    const rentalData = getRentalData();
    const products = rentalData ? rentalData.products : []
    const skus = rentalData ? rentalData.skus : []
    const formattedProducts = products.map(item => {
      const currentSku = skus.find(sku => sku.strId === item.skuId) || {};
      const { color, pricing, size } = currentSku
      return {
        ...item,
        color,
        pricing,
        size
      }
    });

    let rentalInterval = null
    if(rentalData) {
      const { dateFrom, dateTo } = rentalData

      const interval = intervalToDuration({ start: new Date(dateFrom), end: new Date(dateTo) })
      rentalInterval = interval.days + 1;
    }

    return formattedProducts.reduce((acc, cur) => {
      const { pricing, amount } = cur
      let price = 0
      if(cur.pricing) {
        const currentPrice = pricing
          ? pricing
            .find(item => rentalInterval
              ? Number(item.value) === rentalInterval
              : minPrice(pricing))
          : null
        price = currentPrice ? currentPrice.price * amount : 0
      }
      return acc + price
    }, 0)
  }

  const handleDateClick = () => {
    setShowPopup(false)
    setDisabledButton(false)
    setShowModal('dates')
  }

  const handleChangeDayDelivery = (isActive) => {
    setActiveDayDelivery(isActive)
  }

  const handleSetPostcode = (postcode) => {
    onSetPostcode(postcode)
  }

  const handleHideIframe = () => {
    setShowIframe(false);

    eventLog({event_id: 15});
  }

  if(!productData) return null

  return (
    <div className='rntr-container'>
      { Boolean(count) &&
        <CartButton
          count={ count }
          showPopup={ () => { setShowPopup(true); eventLog({event_id: 9}); } }
          showModal={ handleDateClick }
          dateRange={ dateRange }
          totalPrice={ getTotalPrice() }/>
      }
      <RentalModal
        show={ showModal }
        onHide={ handleHide }
        onApply={ handleApply }
        cartData={ cart }
        dateRange={ dateRange }
        disabled={ disabledButton }
        isDesktop={ isDesktop }
        isMobile={ isMobile }
        onChangeDayDelivery={ handleChangeDayDelivery }
        onSetPostcode={ handleSetPostcode }
        isActiveDayDelivery={ isActiveDayDelivery }
        areaPostcode={ areaPostcode }
        productData={ productData }
        isPickUp={ isPickUp }
        sameDayDeliveryAvailable={sameDayDeliveryAvailable}
        vendorSlug={vendorSlug}/>
      {
        showPopup &&
        <CheckoutPopup
          hidePopup={ () => setShowPopup(false) }
          checkCount={ checkCount }
          onDateClick={ handleDateClick }
          dateRange={ dateRange }
          cartData={ cart }
          count={ count }
          setCartData={ setCartData }
          rentalData={ getRentalData() }
          totalPrice={ getTotalPrice() }
          isDesktop={ isDesktop }
          checkDateRange={ checkDateRange }
          productData={ productData }
          isPickUp={ isPickUp }/>
      }
      { showIframe &&
        <IFrame onHide={ handleHideIframe } isMobile={ isMobilePopup }/>
      }
    </div>
  );
}

export default App;
